import React from "react";

const UserMasterSkeletonRow = ({ rowIndex }) => {
    const rowClass = rowIndex % 2 === 0 ? "row-even" : "row-odd";
    return (
        <div className={`card mt-0 quote-project-row user-project-row skeleton-row ${rowClass}`}>
            <div className="card-body">
                <div className="quote-project-grid user-project-grid">
                    <div className="project-cell">
                        <span className="avatar skeleton-block skeleton-avatar" />
                        <div className="project-copy">
                            <span className="skeleton-block skeleton-line skeleton-line-title" />
                            <span className="skeleton-block skeleton-line skeleton-line-sub" />
                        </div>
                    </div>
                    <div className="company-cell"><span className="skeleton-block skeleton-line" /></div>
                    <div className="type-cell"><span className="skeleton-block skeleton-line skeleton-line-short" /></div>
                    <div className="role-cell"><span className="skeleton-block skeleton-line" /></div>
                    <div className="status-cell"><span className="skeleton-block skeleton-pill" /></div>
                    <div className="open-cell"></div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(UserMasterSkeletonRow);